module.exports = __webpack_public_path__ + "media/images/new/icons/clock-small-e5128618c8f2e2d7bcc3260a4480bb96.png";